import {
  ElementProps,
  Element as ElementVideoEngine,
} from "@repo/video-engine-i2v/components/Element/Element";
import { useUpdateBoundingBox, useMovingElement } from "./element-hooks";

export default function Element(props: ElementProps) {
  const { movingElement } = useMovingElement(props.element);
  const updateBoundingBox = useUpdateBoundingBox(props.element);

  return (
    <ElementVideoEngine
      {...props}
      movingElement={movingElement}
      updateBoundingBox={updateBoundingBox}
      isEditor
    />
  );
}
